import { z, ZodString } from "zod";
import { errorMessage } from "../helper/errorMessage";
import { regex } from "../helper/regex";

const NAME_LENGTH_LIMIT = 50;

export const getNameValidator = (
  fieldName: string,
  nameErrorMessageFormat?: string,
  optional: boolean = false
): ZodString =>
  z
    .string()
    .regex(regex.legalName, {
      message: errorMessage(nameErrorMessageFormat || "invalid-format-name-md"),
    })
    .min(optional ? 0 : 1, {
      message: errorMessage("required-field", { field: fieldName }),
    })
    .max(NAME_LENGTH_LIMIT, {
      message: errorMessage("character-length-exceeded", {
        field: fieldName,
        max: NAME_LENGTH_LIMIT,
      }),
    });
